import React, { useEffect, useState } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { FormButtons, renderers, validations } from '../../../components'
import { Field, reduxForm } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
import { getLists } from '../../../state/lists'

export const UPLOAD_FORM_NAME = 'UploadDocumentForm'
const FILE_FIELD_NAME = 'files'
let UploadDocumentFormHTML = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
    uploadMessage
}) => {

  const dispatch = useDispatch()
  const { upload_document_types } = useSelector((state) => state.lists)

  const handleOnDrop = (newImageFile, onChange) => {
    onChange(newImageFile[0])
  }

  useEffect(() => {
    !upload_document_types && dispatch(getLists('UPLOAD_DOCUMENT_TYPES'))
  }, [upload_document_types, dispatch])

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <Field
            name={FILE_FIELD_NAME}
            handleOnDrop={handleOnDrop}
            component={renderers.renderDropzoneInput}
          />

          <Field
            component={renderers.renderSelectField}
            as="select"
            name="upload_type"
            label="Type"
            validate={[validations.required]}
          >
            {upload_document_types &&
              upload_document_types.map(({url, value}) => (
                <option key={url} value={value}>
                  {value}
                </option>
              ))}
          </Field>
           <Field
            component={renderers.renderSelectField}
            as="select"
            name="gsx_module_type"
            label="GSX Module Type"
          >
             <option key={"do_not"} value={undefined}>
                  Don't Upload to GSX
                </option>

            {[{
              value:"repair",
              label:"Repair"
            },{
              value:"appleCareOrder",
              label:"Apple Care Order"
            },{
              value:"escalationRequote",
              label:"Escalation Requote"
            },{
              value:"otherEscalations",
              label:"Other Escalations"
            }].map((v) => (
                <option key={v.value} value={v.value}>
                  Upload to GSX as {v.label}
                </option>
              ))}
          </Field>
          <Field
            component={renderers.renderTextArea}
            className="form-control"
            label="Description"
            name="description"
            id="note"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12" className={"text-end"}>
        {uploadMessage && <h6>{uploadMessage}</h6>}
        </ReactBootstrap.Col>
        <ReactBootstrap.Col xs="12">
          <FormButtons
            submitting={submitting}
            pristine={pristine}
            reset={reset}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
export const UploadForm = reduxForm({
  form: UPLOAD_FORM_NAME,
})(UploadDocumentFormHTML)
